import React from 'react'
import classNames from 'classnames'

/**
 * CheckControl
 * @param {Object} props
 * @param {boolean} props.active - Whether the checkbox is active/checked
 * @param {boolean} [props.disabled] - Whether the checkbox is disabled
 * @param {function} [props.onToggle] - Click handler
 * @param {string} [props.className] - Additional classes
 * @param {string} [props.activeColor] - Custom color when active (border and background); default active uses brand-04 fill
 * @param {string} [props.inactiveColor] - Custom color when inactive (applied to border)
 */
const CheckControl = ({ active, disabled, onToggle, className, activeColor, inactiveColor }) => {
  const useCustomColors = activeColor || inactiveColor
  const isMarkersActive = className?.includes('markers-active')
  const usesDefaultActiveStyle = active && !isMarkersActive && !useCustomColors

  const boxStyle = {}
  if (isMarkersActive && active) {
    boxStyle.backgroundColor = 'currentColor'
    boxStyle.borderColor = 'currentColor'
  } else if (useCustomColors && !isMarkersActive) {
    if (active && activeColor) {
      boxStyle.backgroundColor = activeColor
      boxStyle.borderColor = activeColor
    } else if (!active && inactiveColor) {
      boxStyle.borderColor = inactiveColor
    }
  } else if (usesDefaultActiveStyle) {
    boxStyle.backgroundColor = 'var(--color-brand-04)'
    boxStyle.borderColor = 'var(--color-brand-04)'
  }

  const checkColor = isMarkersActive ? 'currentColor' : 'var(--color-Neutral-1)'

  return (
    <div
      onClick={!disabled ? onToggle : () => {}}
      className={classNames(
        'w-[18px] h-[18px] relative border-2 border-solid border-[var(--color-Neutral-3)] rounded-[4px] transition-colors duration-200',
        {
          'bg-surface-1': !usesDefaultActiveStyle && !disabled,
          'bg-[var(--color-Neutral-3)] border-[var(--color-Neutral-3)]': disabled,
        },
        className,
      )}
      style={boxStyle}>
      {active && (
        <svg
          className="absolute left-1/2 top-1/2 h-[14px] w-[14px] -translate-x-1/2 -translate-y-1/2"
          style={{ color: checkColor }}
          viewBox="0 0 14 14"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden>
          <polyline points="2,7 6,11 12,3" />
        </svg>
      )}
    </div>
  )
}

export default CheckControl
